import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import "swiper/css/pagination";
import { Container } from '../common/AltCard';
// import { Autoplay, Pagination } from 'swiper/modules';
import { Autoplay, Pagination } from "swiper";

const Testimonials3 = () => {
  return (
    <section className='bg-secondary py-6 lg:py-20'>
      <Container>
      <h4 style={{letterSpacing:'0.5px'}} className='text-[#35393F] lg:text-center font-int font-bold mb-6  text-2xl md:text-5xl'>Hear Our <span className='font-playfair italic text-[32px] md:text-[50px] lg:text-[4rem] font-[800] text-primary'>Feedbacks</span></h4> 
          <div className='flex mx-[-15px] pb-[-15px] flex-wrap justify-center items-center flex-row content-stretch py-6'>

              <div className=' lg:pl-[30px]   lg:mb-[15px] flex-1  lg:basis-[50%] w-full lg:w-[50%]'>
                  {/* the swiper */}


              <Swiper
                spaceBetween={30}
                // centeredSlides={true}
                autoplay={{
                  delay: 4500,
                  disableOnInteraction: true,
                }}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  320: { slidesPerView: 1 }, // Mobile devices
                  640: { slidesPerView: 2 }, // Small tablets
                  1024: { slidesPerView: 3 }, // Laptops and larger tablets
                  1280: { slidesPerView: 3 }, // Desktops
                }}
                navigation={true}
                modules={[Autoplay, Pagination]}
                className="mySwiper"
              >
                {
                  testimonialData.map((i, id)=>(
                    <SwiperSlide>
                    <div className='shadow-lg rounded-lg px-4 bg-white h-[200px] pt-4 pb-6'>
                      <span className='mb-3'>⭐⭐⭐⭐⭐</span>
                      <div className='mb-6 flex flex-col justify-between h-full'>
                        <p className='text-[#555C63]'>{i.text}</p>
                        <div className='flex items-center '>
                            <img src="" alt="" />
                            <div className='self-start'>
                              <h5 className='font-bold text-[#263238] text-lg'>{i.owner}</h5 >
                              <h6 className='text-xs text-[#35393F] font-thin italic'>{i.location}</h6>
                            </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>                    
                  ))
                }



                

              </Swiper>

              </div>


          </div>

      </Container>


      
    </section>
  )
}

export default Testimonials3

 const TestimonyCard = ()=>{
  return(
    <div className='shadow-lg rounded-lg bg-white h-[200px] p-4'>
      <div className='mb-6'>
        <p>This is the best sustainable app I’ve ever seen. Quality services. Keep up the good work.</p>
        <div className='flex items-center '>
            <img src="" alt="" />
            <div className='self-start'>
              <h5 className='text-[#35393F] font-bold text-[#263238] text-lg'>Jadesola Samuel</h5 >
              <h6 className='text-xs text-[#35393F] font-thin italic'>Household User</h6>
            </div>
        </div>
      </div>
    </div>
  )
 }

 const testimonialData = [
  {
    text:"Since joining Pakam, my income has become more stable. The digital platform makes it easier to log collections and get paid faster. It's a game-changer for us at the grassroots",
    img:'',
    owner:'Grace Eze',
    location:'Waste Aggregator, Lagos'
  },
  {
    text:"Pakam has brought transparency to our waste collection and reporting processes. Monitoring daily activities in real-time has helped improve efficiency and reduce fraud.",
    img:'',
    owner:'Tunde Ajayi',
    location:'Municipal Officer, Lagos Waste Management Authority'
  },
  {
    text:"We now get reliable data on recyclable material sourcing, thanks to Pakam. It connects us to verified collectors and helps streamline operations.",
    img:'',
    owner:'Blessing Oluwaseyi',
    location:'Recycling Company Owner'
  },
  {
    text:'So far the app has help change so many things like theft and also it make the app more transparent and swift in attending to staffs',
    img:'',
    owner:'Sarah Keller ',
    location:'Lagos, Nigeria.'
  },
  {
    text:"With Pakam, we now have access to reliable data on recyclable material sourcing. It connects us with verified collectors and significantly improves the efficiency of our operations.",
    img:'',
    owner:'Michael Ode',
    location:'Recycling Company Owner'
  },
 ]
